// Date helpers. Every stored date is a "YYYY-MM-DD" string.
//
// Always parse with d(). `new Date("2026-09-21")` parses as UTC midnight, which is the
// previous evening in Boston — deliverables then show up on the wrong day. d() builds a
// local-midnight Date instead.

export const DAYNAME = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2026-09-21" → local-midnight Date. */
export function d(isoStr) {
  const [y, m, day] = isoStr.split("-").map(Number);
  return new Date(y, m - 1, day);
}

/** Date → "2026-09-21". */
export function iso(dt) {
  return (
    dt.getFullYear() +
    "-" +
    String(dt.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(dt.getDate()).padStart(2, "0")
  );
}

/** "2026-09-21" → "Sep 21" */
export function fmt(s) {
  const t = d(s);
  return MON[t.getMonth()] + " " + t.getDate();
}

/** "2026-09-21" → "Mon Sep 21" */
export function fmtFull(s) {
  const t = d(s);
  return DAYNAME[t.getDay()].slice(0, 3) + " " + MON[t.getMonth()] + " " + t.getDate();
}

export function addDays(dt, n) {
  const x = new Date(dt);
  x.setDate(x.getDate() + n);
  return x;
}

/** Local midnight today. */
export function today() {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}

/** Monday of the ISO week containing dt (weeks run Monday–Sunday). */
export function mondayOf(dt) {
  const day = (dt.getDay() + 6) % 7; // Mon = 0 … Sun = 6
  return addDays(dt, -day);
}

/**
 * The Friday of the current ISO week — the anchor for the rolling three-week window.
 *
 * On a Saturday this returns yesterday, which is intended: the window is keyed to the
 * week you are in, not to the next Friday ahead. Because it derives from today(), the
 * window rolls forward on its own. Do not replace with "today + 21 days".
 */
export function anchorFriday(base) {
  return addDays(mondayOf(base), 4);
}

/** Whole days from a to b. Negative when b is in the past. */
export function daysBetween(a, b) {
  return Math.round((b - a) / 86400000);
}
